<div class="hidden-xs hidden-sm">
  <div class="container-fluid header-background" [class.is-wcm]="isWCM">
    <div class="header-logo" [class.no-logo]="!userDivision">
      <ng-container *ngIf="pitchExpired$ | async">
        <span class="header-logo__expired bg-warning">expired</span>
      </ng-container>
    </div>
    <div class="container pitch-header">
      <div class="row">
        <div class="header-content col-xs-10 col-sm-8 col-md-7 col-md-offset-1">
          <h1 class="text-white weight-heavy">{{ pitch.name }}</h1>
          <h4 class="text-white weight-regular" *ngIf="pitch.description">{{ pitch.description }}</h4>
          <h4 class="text-white weight-regular" *ngIf="!pitch.description"></h4>
        </div>
        <div class="text-white metadata-chunks col-xs-2 col-sm-4 col-md-3">
          <div class="row metadata-row">
            <span class="metadata-label">CREATED</span><br />
            <span class="weight-heavy metadata-value">{{ pitch.createdTime | date: 'MMM d, y' }}</span>
          </div>
          <div class="row metadata-row">
            <span class="metadata-label">EXPIRATION</span><br />
            <span class="weight-heavy metadata-value" *ngIf="pitch.expectedExpirationDate">
              {{ pitch.expectedExpirationDate | date: 'MMM d, y' }}
            </span>
            <span class="weight-heavy metadata-value" *ngIf="!pitch.expectedExpirationDate">
              EXPIRED
            </span>
          </div>
          <div class="row metadata-row">
            <span class="metadata-label">CONTRIBUTORS</span><br />
            <span class="weight-heavy metadata-value">{{ pitch.createdBy }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="hidden-md hidden-lg hidden-xl">
  <div class="header-background" [class.is-wcm]="isWCM">
    <div class="header-logo">
      <ng-container *ngIf="pitchExpired$ | async">
        <span class="header-logo__expired bg-warning">expired</span>
      </ng-container>
    </div>
    <div class="container pitch-header">
      <div class="row">
        <div class="header-content col-xs-10 col-xs-offset-1 col-sm-8 col-md-7 col-md-offset-1">
          <h1 class="text-white weight-heavy">{{ pitch.name }}</h1>
          <h4 class="text-white weight-regular" *ngIf="pitch.description">{{ pitch.description }}</h4>
        </div>
        <div class="text-white metadata-chunks col-xs-12 col-sm-2 col-md-3">
          <div class="row">
            <div class="metadata-row col-xs-6 col-sm-12">
              <span class="metadata-label">CREATED</span><br />
              <span class="weight-heavy metadata-value">{{ pitch.createdTime | date: 'MMM d, y' }}</span>
            </div>
            <div class="metadata-row col-xs-6 col-sm-12">
              <span class="metadata-label">EXPIRATION</span><br />
              <span class="weight-heavy metadata-value" *ngIf="pitch.expectedExpirationDate">
                {{ pitch.expectedExpirationDate | date: 'MMM d, y' }}
              </span>
              <span class="weight-heavy metadata-value" *ngIf="!pitch.expectedExpirationDate">
                EXPIRED
              </span>
            </div>
            <div class="metadata-row col-xs-12 col-sm-12">
              <span class="metadata-label">CONTRIBUTORS</span><br />
              <span class="weight-heavy metadata-value">{{ pitch.createdBy }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
